import { render } from "./GalleryOverview.vue?vue&type=template&id=4321cfe1"
import script from "./GalleryOverview.vue?vue&type=script&lang=js"
export * from "./GalleryOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__